import { render, staticRenderFns } from "./CollapsableCard.vue?vue&type=template&id=4e7edfe8&scoped=true"
import script from "./CollapsableCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollapsableCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CollapsableCard.vue?vue&type=style&index=0&id=4e7edfe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7edfe8",
  null
  
)

export default component.exports